<template>
    <div class="text-center">
        <vc-calendar
            :masks="masks"
            :attributes="calendarEvents"
            :locale="$i18n.locale"
            class="custom-calendar max-w-full"
            disable-page-swipe
            is-expanded
        >
            <template #day-content="{ day, attributes }">
                <div class="flex flex-col h-full z-10 overflow-hidden">
                    <span class="day-label text-sm text-gray-900">{{
                        day.day
                    }}</span>
                    <div class="flex-grow overflow-y-auto overflow-x-auto">
                        <p
                            v-for="attr in attributes"
                            :key="attr.key"
                            :class="attr.customData.class"
                            class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1 is-clickable"
                            @click="$emit('viewEvent', attr)"
                        >
                            {{ attr.customData.title }}
                        </p>
                    </div>
                </div>
            </template>
        </vc-calendar>
    </div>
</template>

<script>
export default {
    props: {
        calendarEvents: {
            type: [Array],
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            masks: {
                weekdays: 'WWW',
            },
        };
    },
};
</script>
<style lang="scss" scoped>
@import '../assets/css/vcalendar.css';
::-webkit-scrollbar {
    width: 0px;
}
::-webkit-scrollbar-track {
    display: none;
}
/deep/ .custom-calendar.vc-container {
    --day-border: 1px solid #b8c2cc;
    --day-border-highlight: 1px solid #b8c2cc;
    --day-width: 90px;
    --day-height: 90px;
    --weekday-bg: #f8fafc;
    --weekday-border: 1px solid #eaeaea;
    border-radius: 0;
    width: 100%;
    & .vc-header {
        background-color: #f1f5f8;
        padding: 10px 0;
    }
    & .vc-weeks {
        padding: 0;
    }
    & .vc-weekday {
        background-color: var(--weekday-bg);
        border-bottom: var(--weekday-border);
        border-top: var(--weekday-border);
        padding: 5px 0;
    }
    & .vc-day {
        padding: 0 5px 3px 5px;
        text-align: left;
        height: var(--day-height);
        min-width: var(--day-width);
        background-color: white;
        &.weekday-1,
        &.weekday-7 {
            background-color: #eff8ff;
        }
        &:not(.on-bottom) {
            border-bottom: var(--day-border);
            &.weekday-1 {
                border-bottom: var(--day-border-highlight);
            }
        }
        &:not(.on-right) {
            border-right: var(--day-border);
        }
    }
    & .vc-day-dots {
        margin-bottom: 5px;
    }
}
.bg-color-4398e1 {
    background-color: #4398e1;
}
.bg-color-dfac2d {
    background-color: #dfac2d;
}
.bg-color-9761c6 {
    background-color: #9761c6;
}
.bg-color-90be61 {
    background-color: #90be61;
}
.bg-color-ce527c {
    background-color: #ce527c;
}
.bg-color-cbc02e {
    background-color: #cbc02e;
}
</style>
